// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.glitch {
  color: #fff;
  font-size: var(--glitch-size, clamp(2rem, 10vw, 8rem));
  white-space: var(--glitch-whitespace, nowrap);
  font-weight: 900;
  position: relative;
  margin: 0 auto;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  display: block;
  width: 100%;
  text-align: inherit;
}

.glitch::after,
.glitch::before {
  content: attr(data-text);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  color: #fff;
  background-color: var(--glitch-bg, transparent);
  overflow: hidden;
  clip-path: inset(0 0 0 0);
  white-space: inherit;
  width: 100%;
  text-align: inherit;
  line-height: inherit;
}

.glitch:not(.enable-on-hover)::after {
  left: 10px;
  text-shadow: var(--after-shadow, -10px 0 red);
  animation: animate-glitch var(--after-duration, 3s) infinite linear alternate-reverse;
}
.glitch:not(.enable-on-hover)::before {
  left: -10px;
  text-shadow: var(--before-shadow, 10px 0 cyan);
  animation: animate-glitch var(--before-duration, 2s) infinite linear alternate-reverse;
}

.glitch.enable-on-hover::after,
.glitch.enable-on-hover::before {
  content: '';
  opacity: 0;
  animation: none;
}

.glitch.enable-on-hover:hover::after {
  content: attr(data-text);
  opacity: 1;
  left: 10px;
  text-shadow: var(--after-shadow, -10px 0 red);
  animation: animate-glitch var(--after-duration, 3s) infinite linear alternate-reverse;
}
.glitch.enable-on-hover:hover::before {
  content: attr(data-text);
  opacity: 1;
  left: -10px;
  text-shadow: var(--before-shadow, 10px 0 cyan);
  animation: animate-glitch var(--before-duration, 2s) infinite linear alternate-reverse;
}

@keyframes animate-glitch {
  0% {
    clip-path: inset(20% 0 50% 0);
  }
  5% {
    clip-path: inset(10% 0 60% 0);
  }
  10% {
    clip-path: inset(15% 0 55% 0);
  }
  15% {
    clip-path: inset(25% 0 35% 0);
  }
  20% {
    clip-path: inset(30% 0 40% 0);
  }
  25% {
    clip-path: inset(40% 0 20% 0);
  }
  30% {
    clip-path: inset(10% 0 60% 0);
  }
  35% {
    clip-path: inset(15% 0 55% 0);
  }
  40% {
    clip-path: inset(25% 0 35% 0);
  }
  45% {
    clip-path: inset(30% 0 40% 0);
  }
  50% {
    clip-path: inset(20% 0 50% 0);
  }
  55% {
    clip-path: inset(10% 0 60% 0);
  }
  60% {
    clip-path: inset(15% 0 55% 0);
  }
  65% {
    clip-path: inset(25% 0 35% 0);
  }
  70% {
    clip-path: inset(30% 0 40% 0);
  }
  75% {
    clip-path: inset(40% 0 20% 0);
  }
  80% {
    clip-path: inset(20% 0 50% 0);
  }
  85% {
    clip-path: inset(10% 0 60% 0);
  }
  90% {
    clip-path: inset(15% 0 55% 0);
  }
  95% {
    clip-path: inset(25% 0 35% 0);
  }
  100% {
    clip-path: inset(30% 0 40% 0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/GlitchText.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,sDAAsD;EACtD,6CAA6C;EAC7C,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,wBAAwB;EACxB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,WAAW;EACX,+CAA+C;EAC/C,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,6CAA6C;EAC7C,qFAAqF;AACvF;AACA;EACE,WAAW;EACX,8CAA8C;EAC9C,sFAAsF;AACxF;;AAEA;;EAEE,WAAW;EACX,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,UAAU;EACV,6CAA6C;EAC7C,qFAAqF;AACvF;AACA;EACE,wBAAwB;EACxB,UAAU;EACV,WAAW;EACX,8CAA8C;EAC9C,sFAAsF;AACxF;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;AACF","sourcesContent":[".glitch {\n  color: #fff;\n  font-size: var(--glitch-size, clamp(2rem, 10vw, 8rem));\n  white-space: var(--glitch-whitespace, nowrap);\n  font-weight: 900;\n  position: relative;\n  margin: 0 auto;\n  user-select: none;\n  cursor: pointer;\n  display: block;\n  width: 100%;\n  text-align: inherit;\n}\n\n.glitch::after,\n.glitch::before {\n  content: attr(data-text);\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  color: #fff;\n  background-color: var(--glitch-bg, transparent);\n  overflow: hidden;\n  clip-path: inset(0 0 0 0);\n  white-space: inherit;\n  width: 100%;\n  text-align: inherit;\n  line-height: inherit;\n}\n\n.glitch:not(.enable-on-hover)::after {\n  left: 10px;\n  text-shadow: var(--after-shadow, -10px 0 red);\n  animation: animate-glitch var(--after-duration, 3s) infinite linear alternate-reverse;\n}\n.glitch:not(.enable-on-hover)::before {\n  left: -10px;\n  text-shadow: var(--before-shadow, 10px 0 cyan);\n  animation: animate-glitch var(--before-duration, 2s) infinite linear alternate-reverse;\n}\n\n.glitch.enable-on-hover::after,\n.glitch.enable-on-hover::before {\n  content: '';\n  opacity: 0;\n  animation: none;\n}\n\n.glitch.enable-on-hover:hover::after {\n  content: attr(data-text);\n  opacity: 1;\n  left: 10px;\n  text-shadow: var(--after-shadow, -10px 0 red);\n  animation: animate-glitch var(--after-duration, 3s) infinite linear alternate-reverse;\n}\n.glitch.enable-on-hover:hover::before {\n  content: attr(data-text);\n  opacity: 1;\n  left: -10px;\n  text-shadow: var(--before-shadow, 10px 0 cyan);\n  animation: animate-glitch var(--before-duration, 2s) infinite linear alternate-reverse;\n}\n\n@keyframes animate-glitch {\n  0% {\n    clip-path: inset(20% 0 50% 0);\n  }\n  5% {\n    clip-path: inset(10% 0 60% 0);\n  }\n  10% {\n    clip-path: inset(15% 0 55% 0);\n  }\n  15% {\n    clip-path: inset(25% 0 35% 0);\n  }\n  20% {\n    clip-path: inset(30% 0 40% 0);\n  }\n  25% {\n    clip-path: inset(40% 0 20% 0);\n  }\n  30% {\n    clip-path: inset(10% 0 60% 0);\n  }\n  35% {\n    clip-path: inset(15% 0 55% 0);\n  }\n  40% {\n    clip-path: inset(25% 0 35% 0);\n  }\n  45% {\n    clip-path: inset(30% 0 40% 0);\n  }\n  50% {\n    clip-path: inset(20% 0 50% 0);\n  }\n  55% {\n    clip-path: inset(10% 0 60% 0);\n  }\n  60% {\n    clip-path: inset(15% 0 55% 0);\n  }\n  65% {\n    clip-path: inset(25% 0 35% 0);\n  }\n  70% {\n    clip-path: inset(30% 0 40% 0);\n  }\n  75% {\n    clip-path: inset(40% 0 20% 0);\n  }\n  80% {\n    clip-path: inset(20% 0 50% 0);\n  }\n  85% {\n    clip-path: inset(10% 0 60% 0);\n  }\n  90% {\n    clip-path: inset(15% 0 55% 0);\n  }\n  95% {\n    clip-path: inset(25% 0 35% 0);\n  }\n  100% {\n    clip-path: inset(30% 0 40% 0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
